import store from '../../../store';
import { myV1ActionEvent } from 'v4/migration/actionAsEventMiddleware.connected';
import { createReduxProxy } from './reduxProxy';

export const myReduxProxy = createReduxProxy({
  dispatch: action => {
    store.dispatch(action);
  },
  read: myV1ActionEvent
});
